import { defineStore } from 'pinia'
import { computed } from '@nuxtjs/composition-api'
import { calculateSum } from '@shared/utils'
import { IOrderInner } from '@entities/order/model/types'
import { useOrderModel } from '@entities/order'

export const useOrderModelWidget = defineStore('orderWidget', () => {
  const orderModel = useOrderModel()

  const sumOrder = computed(() => {
    if (!orderModel.divideCheck) {
      if (orderModel.orderData && orderModel.orderData.orders) {
        return orderModel.orderData.orders?.reduce((sum: number, orderElement: IOrderInner) => sum + orderElement.fullPaySum, 0) / 100 ?? 0
      }
      return 0
    }
    return parseFloat(calculateSum(orderModel.orderElements).toFixed(2))
  })

  return {
    sumOrder
  }
})
